import { teamsClient } from '@atlaskit/teams-client';

import { type StoreApi } from '../../types';

export const getTeamAgents =
	(teamId: string, keepExistingData?: boolean) =>
	async ({ getState, setState }: StoreApi): Promise<void> => {
		if (!keepExistingData) {
			setState({
				teamAgents: {
					teamId,
					isLoading: true,
					isLoadingNextPage: false,
					hasLoaded: false,
					hasError: false,
					errorType: null,
					members: [],
					agents: [],
				},
			});
		}

		if (getState().teamAgents.teamId !== teamId) {
			setState({
				teamAgents: {
					...getState().teamAgents,
					isLoading: false,
					isLoadingNextPage: false,
					hasLoaded: false,
					hasError: false,
					errorType: null,
				},
			});
			return;
		}

		setState({
			teamAgents: {
				...getState().teamAgents,
			},
		});

		try {
			const agentsResponse = await teamsClient.queryTeamHasAgents(teamId);

			setState({
				teamAgents: {
					...getState().teamAgents,
					isLoading: false,
					hasLoaded: true,
					hasError: false,
					errorType: null,
					agents: agentsResponse,
				},
			});
		} catch (error) {
			if (getState().teamAgents.teamId !== teamId) {
				return;
			}

			setState({
				teamAgents: {
					...getState().teamAgents,
					isLoading: false,
					hasLoaded: true,
					hasError: true,
					members: [],
					agents: [],
					errorType: error as Error,
				},
			});
		}
	};
